export default [
  {
    key: 'id',
    type: 'id',
    visibility: ['view'],
  },
  {
    key: 'name',
    label: 'Nama',
    type: 'profile',
    image: 'photo',
  },
  {
    key: 'username',
    label: 'Username',
    visibility: ['view'],
  },
  {
    key: 'email',
    label: 'Email',
    type: 'email',
  },
  {
    key: 'phone',
    label: 'Nomor HP',
    type: 'whatsapp',
    prefix: '+',
  },
  {
    key: 'point',
    label: 'Mini Poin',
    type: 'number',
    suffix: ' Poin',
    filter: {
      type: 'number_range',
      gteKey: 'point_gte',
      ltKey: 'point_lt',
      placeholderGte: 'Min',
      placeholderLt: 'Max',
    },
  },
  {
    key: 'mini_wallet_balance',
    label: 'Mini Wallet',
    type: 'number',
    prefix: 'Rp ',
  },
  {
    key: 'referral_code',
    label: 'Kode Referral',
    visibility: ['view'],
  },
  {
    key: 'last_active_at',
    label: 'Aktif Terakhir',
    type: 'datetime',
    visibility: ['view'],
  },
  {
    key: 'email_verified_at',
    label: 'Email Diverifikasi',
    type: 'datetime',
    visibility: ['view'],
  },
  {
    key: 'phone_verified_at',
    label: 'Telepon Diverifikasi',
    type: 'datetime',
    visibility: ['view'],
  },
  {
    key: 'is_beta_tester',
    label: 'Beta User',
    type: 'boolean',
    filter: {
      key: 'is_beta_tester',
      type: 'select',
      label: 'Peran',
      options: [
        { value: true, text: 'Beta User' },
      ],
    },
  },
  {
    key: 'registry_product_count',
    label: 'Jumlah Registry',
    type: 'number',
    visibility: ['view'],
  },
  {
    key: 'dont_switch_external_registry',
    label: 'Nonaktifkan External Registry',
    visibility: ['view'],
  },
  {
    key: 'created_at',
    label: 'Terdaftar',
    type: 'datetime',
    filter: {
      type: 'datetime',
      startKey: 'created_at_gte',
      endKey: 'created_at_lt',
    },
  },
]
